const placeHoldersSource = {
  image_highlight: '/webclient/sk_core/images/place_hl.png',
  image_large: '/webclient/sk_core/images/place_large.png',
  image_medium: '/webclient/sk_core/images/place_medium.png',
  image_small: '/webclient/sk_core/images/place_small.png',
  ext_eventimage_name: '/webclient/sk_core/images/place_medium.png',
};

class placeHolders {
  static getPlaceHolders() {
    return placeHoldersSource;
  }

  static getManyPlaceHolders(numberOfPlaceHolders) {
    const howMany = numberOfPlaceHolders || 8;
    const __placeHolders = [];

    for (let i = 0; i < howMany; i++) {
      __placeHolders.push(placeHoldersSource);
    }

    return __placeHolders;
  }
}

export default placeHolders;
